import Widget from "./Widget"
import WidgetSection from "./WidgetSection"
import WidgetImage from "./WidgetImage"

export { WidgetSection, WidgetImage }

export default Widget
